var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessagePos = function SvgMessagePos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 37,
    viewBox: "0 0 1.25 1.17",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.1.14c.09.21.12.67.14.92 0 .01.81.06.91 0 .03-.02 0-.67.02-.81C1.19.03 1.15.09.86.09c-.1 0-.71 0-.74.03L.1.14z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.16,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.32.29c.03.06.04.2.04.27 0 0 .24.02.27 0 .01 0 0-.2.01-.24C.65.26.63.27.55.27.52.27.34.27.33.28L.32.29z",
    fill: "#000"
  })));
};

export default SvgMessagePos;